/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React Base Styles
import colors from "assets/theme/base/colors";
import typography from "assets/theme/base/typography";

const { info, dark, background } = colors;
const { size, lineHeight } =  typography;

const globals = {
  // html: {
  //   scrollBehavior: "smooth",
  // },
  "*, *::before, *::after": {
    margin: 0,
    padding: 0,
  },
  "a, a:link, a:visited": {
    textDecoration: "none !important",
  },
  "a.link, .link, a.link:link, .link:link, a.link:visited, .link:visited": {
    color: `${dark.main} !important`,
    transition: "color 150ms ease-in !important",
  },
  "a.link:hover, .link:hover, a.link:focus, .link:focus": {
    color: `${info.main} !important`,
  },
  "table.MuiTable-root .MuiTableBody-root" : {
    minHeight : "300px",
    display : "contents",
    width : "100%",
    minWidth:"100%"
  },
  ".costum-switch .MuiSwitch-track" : {
    width:`${42}px !important`,
    height:`${26}px !important`,
  },
 
  '.ql-container' : {
    borderRadius:'0 0 .6em .6em',
  },
  '.ql-editor' : {
    minHeight : '10em'
  },
  '.ql-toolbar' : {
    borderRadius:'.4em .4em 0 0'
  },
  '.css-18aleyd-MuiAutocomplete-root .MuiAutocomplete-tag .MuiSvgIcon-root' : {
    fontSize: '18px !important',
    color:"#999999 !important"
  },
  '.css-18aleyd-MuiAutocomplete-root .MuiAutocomplete-tag' : {
    color: '#2b2b2b !important',
    minHeight: '30px',
    backgroundColor: '#eee !important',
  },
  ".productSideBar .MuiDrawer-paper , .chat-drawer .MuiDrawer-paper" : {
    backgroundColor:"transparent",
    position :"static", 
    margin :0,
    height : '100%',
    borderRadius : 0
  },
  '.MuiInputLabel-root':{
    padding : "2px 0 !important"
  },
  '.product-shine-img:before' : {
    content: '""',
    background: 'linear-gradient(90deg, rgba(255,255,255,0.02) 0%, rgba(255,255,255,0.2) 35%, rgba(255,255,255,0) 100%)',
    height:' 200%',
    left: '-280px',
    position: 'absolute',
    top: '-50%',
    transform: 'rotate(35deg)',
    transition: 'all 2s cubic-bezier(.19,1,.22,1)',
    width: '80px',
    zIndex: 9,
  },
  '.product-shine-img:after' : {
    content: '""',
    background:'linear-gradient(90deg, rgba(255,255,255,0.02) 0%, rgba(255,255,255,0.2) 35%, rgba(255,255,255,0) 100%)',
    height: '200%',
    left: '180%',
    position: 'absolute',
    top: '-50%',
    transform: 'rotate(35deg)',
    transition: 'all 2s cubic-bezier(.19,1,.22,1)',
    width: '80px',
    zIndex: 9
  },
  '.product-shine-img:hover:before' : {
    left: '180%',
    transition:' all 2s cubic-bezier(.19,1,.22,1)'
  },
  '.product-shine-img:hover:after' : {
    left: '-280px',
    transition: 'all 2s cubic-bezier(.19,1,.22,1)'
  },
  '.infoCard':{
    position: 'absolute',
    boxSizing:' border-box',
    zIndex: 9,
    minHeight:60, 
    width : "100%",
  },
  '.product-details':{
      
      zIndex: 999,
      top: 0,
      left: 0,
      display: 'flex',
      width: '100%',
      height: '100%',
      padding: '2rem',
      placeContent: 'center',
      placeItems: 'center'
  },
  '.singlePictureContainer':{
      position: 'fixed',
      zIndex: 9,
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      borderRadius: 0,
      backgroundColor:"rgba(0,0,0,0.3)"
  },
  '.mega-menu-container' : {
      fontSize : size.sm,
      lineHeight : lineHeight.md
  },
  '*::-webkit-scrollbar': {
    width: '0.4em',
    backgroundColor:`rgba(206, 212, 218, .5) !important`,
    borderRadius : "4em"
  },
  '*::-webkit-scrollbar-track': {
    webKitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3)',
  },
  '*::-webkit-scrollbar-thumb': {
    outline: '1px solid slategrey',
    background: `linear-gradient(195deg, #EBEFF4, #CED4DA) !important`,
    borderRadius : ".4em"
  },
  '.quantity-details .MuiOutlinedInput-root':{
    borderRadius:0, 
    width:70,
    '& input':{
      textAlign:"center",
      height:"auto"
    }
  },
  '.color-picker-wrapper .MuiOutlinedInput-input' : {
    padding: '0.45rem !important',
  },
  '.color-picker-wrapper .muicc-colorpicker-button':{
    minHeight: '24px',
    width: '24px',
    minWidth: '24px',
    padding: 0,
    margin: '5px'
  },
  '.ColorPicker-makeStyles-root-1' : {
    minHeight: "auto !important"
  },
  '.cart-drawer .MuiDrawer-paper' : {
    margin : 0,
    height : '100%',
    minWidth : 360,
    borderRadius : 0
  },
  '.tooltip-arrow::after' : {
    borderColor: 'transparent transparent #eee transparent !important'
  },
  '.MuiAccordion-region' : {
    backgroundColor : background.card
  },
  '.progress-bar-animated .MuiLinearProgress-bar' : {
    webkitAnimation: 'progress-bar-stripes 1s linear infinite',
    animation: 'progress-bar-stripes 1s linear infinite'
  },
  '.progress-bar-striped .MuiLinearProgress-bar' :  {
      backgroundImage: 'linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent)',
      backgroundSize: '1rem 1rem'
  },
  "@keyframes progress-bar-stripes":{
    '0%' :{
      backgroundPosition: '1rem 0'
    },
    '100%' : {
        backgroundPosition: '0 0'
    }
  }
};

export default globals;
